// extracted by mini-css-extract-plugin
export default {"root":"FullscreenAlert_root__M1UaT","custom-card":"FullscreenAlert_custom-card__B+lD2"};